import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { loadScript } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/loaders.js';
const limelightPlayerCallback = (playerId, eventName, data) => {
    const container = document.getElementById(playerId);
    switch (eventName) {
        case 'onPlayerLoad': {
            const element = container.getElementsByClassName('video-js')[0];
            element.setAttribute('tabindex', '0');
            break;
        }
        case 'onMediaLoad': {
            const video = container.getElementsByTagName('video')[0];
            video.setAttribute('aria-label', data.title);
            break;
        }
    }
};
/**
 * @returns Multimedia component.
 *
 */
export class Multimedia extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * Type of the content: media or channel.
         */
        this.contentType = 'media';
        /**
         * Media type associated with content.
         */
        this.variant = 'video';
        /**
         * Random limelight_playerID to associate with the element.
         */
        this._playerId = '';
        this._isLoaded = false;
    }
    get playerId() {
        return this._playerId;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this._playerId) {
            const num = Math.floor(Math.random() * 900000) + 100000;
            this._playerId = `limelight_player_${num}`;
        }
    }
    async updated(changedProperties) {
        super.updated(changedProperties);
        const element = this.renderRoot.querySelector(`#${this.playerId}`);
        element.innerHTML = '';
        if (this.variant === 'audio') {
            this.classList.add('limelight-audio');
        }
        else {
            this.classList.remove('limelight-audio');
        }
        const observer = new IntersectionObserver(async (entries) => {
            if (entries[0].isIntersecting === true && !this._isLoaded) {
                this._isLoaded = true;
                await this.embedVideo();
            }
        }, { threshold: [0] });
        observer.observe(this.renderRoot);
    }
    /**
     * Embeds limelight_player to associated _playerId.
     */
    async embedVideo() {
        loadScript('//video.limelight.com/player/limelightjs-player.js').then(() => {
            // @ts-ignore 3rd party requirement
            if (!window.limelightPlayerCallback) {
                // @ts-ignore 3rd party requirement
                window.limelightPlayerCallback = limelightPlayerCallback;
            }
            // @ts-ignore 3rd party added to window
            LimelightPlayerUtil.embed({
                playerId: this.playerId,
                [`${this.contentType}Id`]: this.contentId,
                playerFormId: 'cace1bc41a3c4b6fa3d4cc16e02333e2', // TODO: differ based on variant, current implementation is same player for all media variants
            });
        });
    }
    render() {
        return html `<div id="${this.playerId}"></div>`;
    }
    createRenderRoot() {
        return this;
    }
}
__decorate([
    property()
], Multimedia.prototype, "contentType", void 0);
__decorate([
    property()
], Multimedia.prototype, "contentId", void 0);
__decorate([
    property()
], Multimedia.prototype, "variant", void 0);
//# sourceMappingURL=multimedia.js.map